import { render, staticRenderFns } from "./ProdictConfigModal.vue?vue&type=template&id=f1312936"
import script from "./ProdictConfigModal.vue?vue&type=script&lang=js"
export * from "./ProdictConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports